<template>
  <add-main @back="goBack">
    <template slot="nav">
      <div class="uploadQualification_nav">
        <p v-if="classPlanOrgan === 0">添加{{ planLevel }}级开班计划</p>
        <p v-else>编辑{{ planLevel }}级开班计划</p>
      </div>
    </template>
    <template slot="main">
      <div class="qualification-form-main-upload">
        <template>
          <div class="content">
            <vue-scroll :ops="ops">
              <div class="form-wrap">
                <el-form :model="formData"
                         ref="vitaForm"
                         :rules="rules"
                         label-width="100px"
                         size="medium">
                  <fieldset class="qualification-form-fieldset">
                    <legend>本月开班计划</legend>
                    <el-row v-for="(col, index) in formData.qualification_list"
                            :key="index"
                            class="vita-edu-row">
                      <fieldset class="qualification-form-fieldset">
                        <legend>开班计划{{index+1}}</legend>
                        <el-col :span="20">
                          <el-row>
                            <el-col :span="10">
                              <el-form-item label="开始日期"
                                            :prop="'qualification_list.'+index+'.start_date'"
                                            :rules="{required: true, validator: (rule, value, callback) => {validateMonth(rule, value, callback)}, trigger: `change`}">
                                <el-date-picker
                                  v-model="col.start_date"
                                  type="date"
                                  @focus="datePickerOfStart(col)"
                                  @change="changeState(index)"
                                  :picker-options="pickerOptionsStart"
                                  :value-format="'yyyy-MM-dd'"
                                  placeholder="选择日期">
                                </el-date-picker>
                              </el-form-item>
                            </el-col>
                            <el-col :span="10">
                              <el-form-item label="截止日期"
                                            :prop="'qualification_list.'+index+'.end_date'"
                                            :rules="{required: true, validator: (rule, value, callback) => {validateMonth(rule, value, callback)}, trigger: `change`}">
                                <el-date-picker
                                  v-model="col.end_date"
                                  type="date"
                                  @focus="datePickerOfEnd(col)"
                                  :picker-options="pickerOptionsEnd"
                                  :value-format="'yyyy-MM-dd'"
                                  placeholder="选择日期">
                                </el-date-picker>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="10">
                              <el-form-item label="开班地区"
                                            :prop="'qualification_list.'+index+'.province_id'"
                                            :rules="[{required: true,message:'请选择省份',trigger:'change'}]">
                                <el-select
                                  @change="provinceChange(index)"
                                  v-model="col.province_id"
                                  placeholder="请选择省份"
                                >
                                  <el-option
                                    v-for="province in provinceList"
                                    :key="province.id"
                                    :value="province.id"
                                    :label="province.text"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col :span="7">
                              <el-form-item label=""
                                            :prop="'qualification_list.'+index+'.city_id'"
                                            :rules="[{required: true,message:'请选择市',trigger:'change'}]"
                                            label-width="10px">
                                <el-select
                                  @change="cityChange(index)"
                                  v-model="col.city_id"
                                  placeholder="请选择市"
                                >
                                  <el-option
                                    v-for="item in col.cityList"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.id"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col :span="7">
                              <el-form-item label=""
                                            :prop="'qualification_list.'+index+'.county_id'"
                                            :rules="[{required: false,message:'请选择区/县',trigger:'change'}]"
                                            label-width="10px">
                                <el-select
                                  @change="countyChange(index)"
                                  v-model="col.county_id"
                                  placeholder="请选择区/县"
                                >
                                  <el-option
                                    v-for="item in col.countyList"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.id"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="10">
                              <el-form-item label="主讲师"
                                            :prop="'qualification_list.'+index+'.teacher_off_ids'"
                                            :rules="[{required: false,message:'请填写主讲师',trigger:'blur'}]">
          
                                <el-select v-model="col.teacher_off_ids"
                                           :default-first-option="true"
                                           :filter-method="lecturerFilter"
                                           @blur="lecturerBlur"
                                           filterable>
                                  <el-option label="足协指派"
                                             value=""></el-option>
                                  <el-option
                                    v-for="tea in lecturerList"
                                    :key="tea.user_id"
                                    :label="`${tea.teacher_name_unit}`"
                                    :value="tea.user_id"
                                  ></el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="24">
                              <el-form-item label="助理讲师"  class="inline-item-wrap form-item-nomb">
                                <div class="display">
                                  <el-form-item
                                    v-for="(item, ind) in col.assistantLecturer"
                                    label-width="10px"
                                    :prop="'qualification_list.'+index+'.assistantLecturer.' + ind + '.val'"
                                    :rules="{validator: (rule, val,callback) => {return validateAssLec(rule, val,callback, index,ind)}, trigger: `change`}"
                                    class="form-input-item input-item-hasmb"
                                    :key="item.key"
                                  >
                                    <el-select v-model="formData.qualification_list[index].assistantLecturer[ind].val"
                                               :default-first-option="true"
                                               :filter-method="assistantFilter"
                                               @focus="assistantIdx = ind"
                                               @blur="assistantBlur"
                                               filterable>
                                      <el-option :label="item.placeholder"
                                                 value=""></el-option>
                                      <el-option label="足协指派"
                                                 value="足协指派"></el-option>
                                      <el-option
                                        v-for="lecturer in assistantLecturerList"
                                        :key="lecturer.user_id"
                                        :label="`${lecturer.teacher_name_unit}`"
                                        :value="lecturer.user_id"
                                      ></el-option>
                                    </el-select>
                                    <i
                                      v-if="ind > 0"
                                      class="input-icon el-icon-close"
                                      @click="removeHost(item, index)"
                                    ></i>
                                  </el-form-item>
                                  <el-button
                                    type="primary"
                                    size="medium"
                                    icon="el-icon-plus"
                                    @click="addHost(index, {val: '', key: Date.now(), placeholder: '(空)', isTestErr: null}, assistantLecturerList.length - 1)"
                                    :disabled="col.assistantLecturer.length > assistantLecturerList.length - 1"
                                    class="form-item-btn button-hasmb"
                                    style="margin-left:10px"
                                    v-if="col.assistantLecturer.length <2"
                                  >更多
                                  </el-button>
                                </div>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="24">
                              <el-form-item label="讲师助理" class="inline-item-wrap form-item-nomb" v-if="planLevel === 'D'">
                                <div class="display" style="margin-bottom:22px">
                                  <el-form-item
                                    label="姓名"
                                    label-width="50px"
                                    :prop="'qualification_list.'+index+'.lecturer_assistant_name'"
                                    :rules="{required: col.lecturer_assistant_id_number, message:'请输入姓名' , trigger: 'blur'}">
                                    <el-input
                                      placeholder="请输入姓名"
                                      v-model="col.lecturer_assistant_name"
                                      class=" input-item-hasmb"
                                      style="width:100px"
                                    ></el-input>
                                  </el-form-item>
                                  <el-form-item label="身份证号"
                                                :prop="'qualification_list.'+index+'.lecturer_assistant_id_number'"
                                                :rules="{required: col.lecturer_assistant_name, validator: (rule, value, callback) => {validateNumberIdNO(rule, value, callback, true, index)}, trigger: 'blur'}"
                                                label-width="85px" class="input-id-number-input">
                                    <el-input
                                      placeholder="请输入身份证件号"
                                      v-model="col.lecturer_assistant_id_number"
                                      class=" input-item-hasmb"
                                      style="width:150px"
                                    ></el-input>
                                  </el-form-item>
                                  <el-form-item label="证件类型"
                                                label-width="85px"
                                                :prop="'qualification_list.'+index+'.lecturer_assistant_type'"
                                                :rules="{required:false,message:'请选择证件类型',trigger:'change'}"
                                  >
                                    <el-select v-model="col.lecturer_assistant_type"
                                               style='width:150px'
                                               class=" input-item-hasmb">
                                      <el-option
                                        v-for="it in id_types"
                                        :key="it.key"
                                        :label="it.key"
                                        :value="it.value"
                                      >
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </div>
                                <div class="display">
                                  <el-form-item
                                    label="姓名"
                                    label-width="50px"
                                    :prop="'qualification_list.'+index+'.lecturer_assistant_two_name'"
                                    :rules="{required: col.lecturer_assistant_two_id_number, message:'请输入姓名' , trigger: 'blur'}">
                                    <el-input
                                      placeholder="请输入姓名"
                                      v-model="col.lecturer_assistant_two_name"
                                      class=" input-item-hasmb"
                                      style="width:100px"
                                    ></el-input>
                                  </el-form-item>
                                  <el-form-item label="身份证号"
                                                :prop="'qualification_list.'+index+'.lecturer_assistant_two_id_number'"
                                                :rules="{required: col.lecturer_assistant_two_name, validator: (rule, value, callback) => {validateNumberIdNOTwo(rule, value, callback, true, index)}, trigger: 'blur'}"
                                                label-width="85px" class="input-id-number-input">
                                    <el-input
                                      placeholder="请输入身份证件号"
                                      v-model="col.lecturer_assistant_two_id_number"
                                      class=" input-item-hasmb"
                                      style="width:150px"
                                    ></el-input>
                                  </el-form-item>
                                  <el-form-item label="证件类型"
                                                label-width="85px"
                                                :prop="'qualification_list.'+index+'.lecturer_assistant_two_type'"
                                                :rules="{required:false,message:'请选择证件类型',trigger:'change'}"
                                  >
                                    <el-select v-model="col.lecturer_assistant_two_type"
                                               style='width:150px'
                                               class=" input-item-hasmb">
                                      <el-option
                                        v-for="it in id_types"
                                        :key="it.key"
                                        :label="it.key"
                                        :value="it.value"
                                      >
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </div>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="24">
                              <el-form-item label="备注">
                                <el-input
                                  type="textarea"
                                  v-model.trim="col.info"
                                  :rows="3"
                                  :maxlength="200"
                                  placeholder="如有备注，请在此处说明，且备注不超过200个字。"></el-input>
                              </el-form-item>
                              <span class="len"
                                    style="position:absolute;right: 15px;bottom: 20px;color: black">{{col.info.length}}/200</span>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="4">
                          <el-row class="exp-opt">
                            <el-col :span="6"
                                    :offset="6" v-if="formData.qualification_list.length <30">
                              <el-button type="primary"
                                         size="small"
                                         icon="el-icon-plus"
                                         @click="addQualification"
                                         circle></el-button>
                            </el-col>
                            <el-col :span="8"
                                    :offset="4">
                              <el-button
                                v-show="formData.qualification_list.length !== 1"
                                type="danger"
                                size="small"
                                icon="el-icon-minus"
                                @click="delQualification(index)"
                                circle></el-button>
                            </el-col>
                          </el-row>
                          <el-row v-if="index===0">
                            <p
                              style="text-align: center;font-size:16px;margin: 5px">
                              点“+”可添加多个开班计划</p>
                          </el-row>
                        </el-col>
                      </fieldset>
                      
                    </el-row>
                  </fieldset>
                </el-form>
              </div>
            </vue-scroll>
          </div>
          <div class="btns">
            <el-button type="primary"
                       @click="checkForm">提交
            </el-button>
            <el-button type="danger"
                       @click="cancel">取消
            </el-button>
          </div>
        </template>
      </div>
      <yioks-tips :showTips="tipsFlag"
                  tips="请确认提交？"
                  :loading="repeatSubmit"
                  @hideTips="hideTipsDialog"></yioks-tips>
      
      <yioks-tips :showTips="cancelFlag"
                  tips="请确认取消提交？"
                  @hideTips="hideCancelDialog"></yioks-tips>
    </template>
  </add-main>
</template>

<script>
  import ops from "@/assets/js/vuescrollOption";
  import rulesMixin from "@/components/Qualification/form-rules";
  import {signLevelFilters} from '@/assets/js/yioksFilters';
  import fiveMixins from "@/minix/fiveMixins";
  import {area_list} from "@/assets/js/region";
  import { getLecturers } from "@/api/agency/agency";
  import {id_types} from "@/assets/js/select";
  import commonFun from "@/assets/js/yioks";
  import {classPlanEdit,claassPlanOrganInfo} from "@/api/class_plan/api";
  const {idCard_number,checkWork,checkHkongMacao,checkTaiwOld,checkPassport,checkHMT,time} = commonFun;
  const dataTestResultsTea = Array(30).fill(null).map(() => ({
    lecturer_assistant_id_number: {bool: false, msg: ""},
    lecturer_assistant_two_id_number: {bool: false, msg: ""}
  }));
  
  export default {
    name:"uploadQualification",
    mixins:[rulesMixin, fiveMixins],
    created(){
      this.getProvinceList();
      this.getLecturerList();
      this.getClaassPlanOrganInfo();
    },
    data(){
      const validateMonth = (rule, value, callback) => {
        if(!value){
          callback(new Error("请选择开班日期"));
        }else{
          callback();
        }
      };
      const validateAssLec = (rule, value, callback, index,i) => {
        if (this.formData.qualification_list[index].assistantLecturer[i].isTestErr) {
          callback(new Error(this.formData.qualification_list[index].assistantLecturer[i].errMsg));
        } else {
          this.$set(this.formData.qualification_list[index].assistantLecturer[i], "isTestErr", false);
          this.$set(this.formData.qualification_list[index].assistantLecturer[i], "errMsg", '');
          callback();
        }
      };
      const validateNumberIdNO = (rule, value, callback, bool, index) => {
        let id_type = this.formData.qualification_list[index].lecturer_assistant_type;
        let id_name = this.formData.qualification_list[index].lecturer_assistant_name;
        let rules ;
        if(id_type==='id_number'){rules=idCard_number}
        else if(id_type==='idTypeCode_wgjzz'){rules=checkWork}
        else if(id_type==='passport'){rules=checkPassport}
        else if(id_type==='TAI'){rules=checkTaiwOld}
        else if(id_type==='HM'){rules=checkHkongMacao}
        else if(id_type==='idTypeCode_HMT'){rules=checkHMT}
        if (id_name && !value){
          callback(new Error("请输入有效的证件号"));
        }
        if(value){
          if (rules(value)) {
            if (bool) {
              if (dataTestResultsTea[index].lecturer_assistant_id_number.bool) {
                callback(new Error(dataTestResultsTea[index].lecturer_assistant_id_number.msg));
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else callback(new Error("请输入有效的证件号"));
        } else{
          callback();
        }
    
      };
      const validateNumberIdNOTwo = (rule, value, callback, bool, index) => {
        let id_type = this.formData.qualification_list[index].lecturer_assistant_two_type;
        let id_name = this.formData.qualification_list[index].lecturer_assistant_two_name;
        let rules ;
        if(id_type==='id_number'){rules=idCard_number}
        else if(id_type==='idTypeCode_wgjzz'){rules=checkWork}
        else if(id_type==='passport'){rules=checkPassport}
        else if(id_type==='TAI'){rules=checkTaiwOld}
        else if(id_type==='HM'){rules=checkHkongMacao}
        else if(id_type==='idTypeCode_HMT'){rules=checkHMT}
        if (id_name && !value){
          callback(new Error("请输入有效的证件号"));
        }
        if(value){
          if (rules(value)) {
            if (bool) {
              if (dataTestResultsTea[index].lecturer_assistant_two_id_number.bool) {
                callback(new Error(dataTestResultsTea[index].lecturer_assistant_two_id_number.msg));
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else callback(new Error("请输入有效的证件号"));
        } else{
          callback();
        }
    
      };
      return {
        ops:ops(),
        validateMonth,
        validateAssLec,
        validateNumberIdNO,
        validateNumberIdNOTwo,
        id_types,
        cancelFlag:false,
        tipsFlag:false,
        repeatSubmit:false,
        pickerStart:'',
        pickerEnd:'',
        planLevel:this.$route.query.plan_level,
        classPlanOrgan:this.$route.query.classPlanOrgan,
        plan_date:this.$route.query.plan_date,
        assistantIdx: -1,
        formData:{
          plan_id:this.$route.query.plan_id,
          qualification_list:[{
            start_date:'', // 开始时间
            end_date:'', // 结束时间
            teacher_off_ids:'', //主讲师id
            lecturer_assistant_name:"",//讲师助理1
            lecturer_assistant_id_number:"",//讲师助理身份证1
            lecturer_assistant_type:"id_number",//讲师助理身份证类型1
            lecturer_assistant_two_name:"",//讲师助理2
            lecturer_assistant_two_id_number:"",//讲师助理身份证2
            lecturer_assistant_two_type:"id_number",//讲师助理身份证类型2
            info:'',
            province_id:"",
            province_name:"",
            city_id:"",
            city_name:"",
            county_id:"",
            county_name:"",
            cityList:[],
            countyList:[],
            curProvince:"",
            curCity:"",
            curCounty:"",
            // 助理讲师
            assistantLecturer: [
              {
                val: "",
                key: Date.now(),
                placeholder: "(空)",
                isTestErr: null
              }
            ],
          }],
          
        },
        provinceList:[],
        teacherZhuliErrLen: null,
        lecturerList: [], // 讲师
        lecturerStore: [], // 讲师备份
        optionalAssistantLec: [],
        assistantLecturerList: [], // 助理讲师
        assistantStore: [], // 助理讲师备份
        
      }
    },
    components:{
      "add-main":() => import("@/components/LayOut/Common/up-down"),
      "app-footer":() => import("@/components/LayOut/Common/Footer"),
      "yioks-tips":() => import('@/components/Tips/Dialog'),
    },
    
    filters:{
      signLevelFilters,
    },
    computed:{
      pickerOptionsEnd(){
        const pickerStart = this.pickerStart;
        if(pickerStart){
          return {
            disabledDate(time){
              return time.getTime() < Date.parse(pickerStart);
            },
          }
        }else{
          return {
            disabledDate(time){
              return false;
            },
          }
        }
      },
      pickerOptionsStart(){
        return {
          disabledDate: time => {
            let dateStart = new Date(this.plan_date + '-01'); // 移动端使用格式要转成: 2018/10/O1
            dateStart.setMonth(dateStart.getMonth()); // 先置为上个月
            dateStart.setDate(0); // 再置0，变成当前月展后一天
            dateStart.getDate(); // 上个月最后一天
            let dateEnd = new Date(this.plan_date + '-01'); // 这个月第一天
            dateEnd.setMonth(dateEnd.getMonth()+1); // 先置为下个月
            dateEnd.setDate(0); // 再置0，变成当前月展后一天
            dateEnd.getDate(); // 下个月最后一天
            return time.getTime() <= dateStart.getTime() || time.getTime() >= dateEnd.getTime();
          },
        };
      },
      
    },
    
    mounted(){},
    methods:{
      datePickerOfStart(val){
        const {end_date, start_date} = val;
        if(end_date){
          this.pickerEnd = end_date;
        }else{
          this.pickerEnd = null;
        }
      },
      datePickerOfEnd(val){
        const {start_date, end_date} = val;
        if(start_date){
          this.pickerStart = start_date;
        }else{
          this.pickerStart = null;
        }
      },
      goBack(){
        this.$router.go(-1)
      },
      
      changeCheck(check){
        this.formData.enroll_id = check;
      },
      
      addQualification(){
        this.formData.qualification_list.push({
          start_date:'', // 开始时间
          end_date:'', // 结束时间
          teacher_off_ids:'', //主讲师id
          lecturer_assistant_name:"",//讲师助理1
          lecturer_assistant_id_number:"",//讲师助理身份证1
          lecturer_assistant_type:"id_number",//讲师助理身份证类型1
          lecturer_assistant_two_name:"",//讲师助理2
          lecturer_assistant_two_id_number:"",//讲师助理身份证2
          lecturer_assistant_two_type:"id_number",//讲师助理身份证类型2
          info:'',
          province_id:"",
          province_name:"",
          city_id:"",
          city_name:"",
          county_id:"",
          county_name:"",
          cityList:[],
          countyList:[],
          curProvince:"",
          curCity:"",
          curCounty:"",
          // 助理讲师
          assistantLecturer: [
            {
              val: "",
              key: Date.now(),
              placeholder: "(空)",
              isTestErr: null
            }
          ],
        });
      },
      delQualification(idx){
        if(this.formData.qualification_list.length === 1) return;
        this.formData.qualification_list.splice(idx, 1);
      },
      checkForm(){
        this.$refs['vitaForm'].validate((valid) => {
          if(valid){
            this.tipsFlag = true;
          }else{
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 显示后台校验24个学员名单的结果
      testTeaInfo(idx, key, msg, i) {
        const index = idx;
        dataTestResultsTea[index][key].bool = true;
        dataTestResultsTea[index][key].msg = msg;
        this.$nextTick(() => {
          this.$refs["vitaForm"].validateField(
            "qualification_list." + index + "." + key
          );
          if (this.teacherZhuliErrLen-1  === i) {
            for (const item of dataTestResultsTea) {
              item[key].bool = false;
              item[key].msg = "";
            }
          }
        });
      },
  
      // 查询开班计划详情
      getClaassPlanOrganInfo(){
        if(this.classPlanOrgan > 0){ //判断是否是编辑
          claassPlanOrganInfo({
            plan_id:this.$route.query.plan_id
          }).then(({data}) => {
            if(Number(data.status) === 0){
              this.formData.qualification_list = data.result;
              // 循环进行赋值
              this.formData.qualification_list.map((item, idx) =>{
                item.start_date = time(item.start_date);
                item.end_date = time(item.end_date);
                item.lecturer_assistant_type = item.lecturer_assistant_type !== '' ? item.lecturer_assistant_type : "id_number";
                item.lecturer_assistant_two_type = item.lecturer_assistant_two_type !== '' ? item.lecturer_assistant_two_type : "id_number";
                const { province_id, city_id, county_id } = item;
                item.province_id = String(province_id);
                this.provinceChange(idx);
                item.city_id = String(city_id);
                this.cityChange(idx);
                if (county_id){
                  item.county_id = String(county_id);
                  this.countyChange(idx);
                }

                item.teacher_off_ids = item.teacher_off_ids ? Number(item.teacher_off_ids) : "";
                item.assistantLecturer = this.$yioks.nullToStr(item.teacher_ids).split(',').map((it, index) => {
                  return {
                    val: it === '' ? '' : (it === '足协指派' ? it :Number(it)),
                    key: index,
                    isTestErr: null,
                    placeholder: "(空)",
                  };
                });
              });
            }else{
              this.$message.error(res.data.msg);
            }
          });
        }
      },
      // 添加开班计划
      hideTipsDialog(bool, flag){
        if(flag){
          this.repeatSubmit = true;
          const list = this.formData.qualification_list.map(({start_date, end_date, teacher_off_ids,lecturer_assistant_name,
               lecturer_assistant_id_number,lecturer_assistant_type,lecturer_assistant_two_name,
               lecturer_assistant_two_id_number,lecturer_assistant_two_type,info,province_id,province_name,
               city_id,city_name,county_id,county_name,assistantLecturer}, index) => ({
            start_date,
            end_date,
            teacher_off_ids,
            lecturer_assistant_name,
            lecturer_assistant_id_number,
            lecturer_assistant_type:lecturer_assistant_id_number === '' ? '' : lecturer_assistant_type,
            lecturer_assistant_two_name,
            lecturer_assistant_two_id_number,
            lecturer_assistant_two_type:lecturer_assistant_two_id_number === '' ? '' : lecturer_assistant_two_type,
            info,
            province_id,
            province_name,
            city_id,
            city_name,
            county_id,
            county_name,
            lecturer_uuid:index,
            teacher_ids : assistantLecturer.map(item => item.val).join(','),
          }));
//          return;
          classPlanEdit({
            plan_id:this.$route.query.plan_id,
            class_plan_adds:JSON.stringify(list)
          }).then(res => {
            if(Number(res.data.status) === 0){
              this.repeatSubmit = false;
              this.tipsFlag = false;
              if(res.data.result.status != 'OK'){
                if(res.data.result.errorList.length > 0){
                  this.teacherZhuliErrLen = res.data.result.errorList.length;
                  this.$nextTick(() => {
                    for (const [
                      i,
                      {lecturer_assistant_id_number, index_id,lecturer_assistant_two_id_number}
                    ] of res.data.result.errorList.entries()) {
                      if(lecturer_assistant_id_number){
                        this.testTeaInfo(index_id, 'lecturer_assistant_id_number', lecturer_assistant_id_number, i);
                      }
                      if(lecturer_assistant_two_id_number){
                        this.testTeaInfo(index_id, 'lecturer_assistant_two_id_number', lecturer_assistant_two_id_number, i);
                      }
                      
                    }
                  });
                }
                this.$message.error("讲师助理信息填写有误");
              }else{
                this.$router.go(-1)
              }
            }else{
              this.$message.error(res.data.msg);
              this.repeatSubmit = false;
              this.tipsFlag = false;
            }
            
          }).catch(err => {
            this.repeatSubmit = false;
            this.tipsFlag = false
          });
        }else{
          this.repeatSubmit = false;
          this.tipsFlag = false
        }
      },
      // 请确认取消提交
      hideCancelDialog(bool, flag){
        if(flag){
          this.cancelFlag = false;
          this.goBack()
        }
        this.cancelFlag = false;
      },
      // 取消
      cancel(){
        this.cancelFlag = true;
      },
      getTime(time){
        return time.map((t) => {
          const timestamp = new Date(t).getTime();
          return this.$yioks.time(timestamp, false, false);
        });
      },
      
      // 获取省数据
      getProvinceList(){
        const vessel = [];
        for(const reg of area_list){
          vessel.push({
            text:reg.regionName,
            id:reg.id,
          });
        }
        this.provinceList = [...vessel];
      },
      provinceChange(id){
        const vessel = [];
        const curProvince = area_list.find((item) => {
          return item.id == this.formData.qualification_list[id].province_id; // 地区JSON数据中存的是字符串，所以。。。哎，不要 ===
        });
        this.formData.qualification_list[id].curProvince = curProvince;
        this.formData.qualification_list[id].province_name =
          curProvince !== undefined ? curProvince.regionName : "";
        this.formData.qualification_list[id].city_id = "";
        this.formData.qualification_list[id].city_name = "";
        this.cityChange(id);
        if(curProvince !== undefined){
          for(const city of curProvince.city){
            vessel.push({
              text:city.regionName,
              id:city.id,
            });
          }
        }
        this.formData.qualification_list[id].cityList = [...vessel];
      },
      cityChange(id){
        this.formData.qualification_list[id].county_id = "";
        this.formData.qualification_list[id].county_name = "";
        const vessel = [];
        if(this.formData.qualification_list[id].curProvince !== undefined){
          const curCity = this.formData.qualification_list[id].curProvince.city.find((item) => {
            return item.id == this.formData.qualification_list[id].city_id;
          });
          this.formData.qualification_list[id].curCity = curCity;
          this.formData.qualification_list[id].city_name =
            curCity !== undefined ? curCity.regionName : "";
          if(curCity !== undefined && curCity.county){
            for(const county of curCity.county){
              vessel.push({
                text:county.regionName,
                id:county.id,
              });
            }
          }
        }
        this.formData.qualification_list[id].countyList = [...vessel];
      },
      countyChange(id){
        if(this.formData.qualification_list[id].curCity !== undefined){
          const curCounty = this.formData.qualification_list[id].curCity.county.find((item) => {
            return item.id == this.formData.qualification_list[id].county_id;
          });
          this.formData.qualification_list[id].curCounty = curCounty;
          this.formData.qualification_list[id].county_name =
            curCounty !== undefined ? curCounty.regionName : "";
        }
      },
  
      // 获取讲师列表
      getLecturerList() {
        const levels = this.$route.query.plan_level;
        let requestName = null;
        requestName = getLecturers;
        requestName({
          class_level: levels,
        }).then(({ data }) => {
          if (data.status === 0) {
            const assiantList = data.result.teacher_assistant_list;
            const teacherList = data.result.teacher_list;
            this.lecturerList = JSON.parse(JSON.stringify(teacherList));
            this.lecturerStore = JSON.parse(JSON.stringify(teacherList));
            this.optionalAssistantLec = [
              ...assiantList
            ];
            this.assistantLecturerList = JSON.parse(JSON.stringify(assiantList)); // 助理讲师
            this.assistantStore = JSON.parse(JSON.stringify(assiantList));
          }
        });
      },
      lecturerFilter(val) {
        this.lecturerList = JSON.parse(JSON.stringify(this.lecturerStore));
        if(val) {
          this.lecturerList = this.lecturerList.filter((item) => {
            return item.teacher_name_unit.includes(val);
          });
        }
      },
      lecturerBlur() {
        setTimeout(() => {
          this.lecturerList = JSON.parse(JSON.stringify(this.lecturerStore));
        }, 100);
      },
      assistantFilter(val) {
        this.assistantLecturerList = JSON.parse(JSON.stringify(this.assistantStore));
        if(val) {
          this.assistantLecturerList = this.assistantLecturerList.filter((item) => {
            return item.teacher_name_unit.includes(val);
          });
        }
      },
      assistantBlur() {
        setTimeout(() => {
          this.assistantLecturerList = JSON.parse(JSON.stringify(this.assistantStore));
        }, 100);
      },
      removeHost(item, ind) {
        const index = this.formData.qualification_list[ind].assistantLecturer.indexOf(item);
        if (index !== -1) {
          this.formData.qualification_list[ind].assistantLecturer.splice(index, 1);
          this.assistantBlur();
        }
      },
      addHost(index, itemData, length = 1) {
        if (this.formData.qualification_list[index].assistantLecturer.length > length) return;
        this.formData.qualification_list[index].assistantLecturer.push(itemData);
        this.assistantBlur();
      },
      changeState(index){
        if(this.formData.qualification_list[index].start_date){
          let times = new Date(this.formData.qualification_list[index].start_date).getTime();
          let endTimes = '';
          if (this.$route.query.plan_level === "C") {
            endTimes = Number(times) + 24 * 60 * 60 * 1000 * 13;
          } else {
            endTimes = Number(times) + 24 * 60 * 60 * 1000 * 7;
          }
          this.formData.qualification_list[index].end_date = time(endTimes);
        }
      },
    }
  }
</script>
<style lang="stylus">
  @import '~@/assets/css/class';
  .qualification-form-main-upload {
    .content {
      .form-wrap {
        .el-form-item__label {
          color: #FFFFFF;
        }
        
        .continue_education {
          width 65%
        }
        
        .continue_education_level {
          width 100%
          
        }
        
        .vita-edu-row {
          .el-range-separator {
            padding: 0;
          }
          
          .el-date-editor {
            width 323px
          }
          
          .orgPlace {
            width 100%
          }
        }
        $width = 306px;
        
        .gender, .national {
          .el-select {
            width: $width;
          }
        }
      }
    }
    
    .btns {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
<style scoped lang="stylus">
  @import "~@/assets/css/variable";
  .uploadQualification_nav, .qualification-form-main-upload {
    flex: 1 1 auto;
    height: 100%;
  }
  
  .uploadQualification_nav {
    display: flex;
    align-items: center;
    
    p {
      font-size: $font_size_big;
    }
  }
  
  .qualification-form-main-upload {
    width: 100%;
    
    .content {
      height: calc(100% - 60px);
      padding: 20px 0;
      position: relative;
      background-color: $block_bg_color_base;
      
      .form-wrap {
        padding: 0 30px 0 25px;
        
        .vita-edu-row .el-date-editor {
          width: 135px;
        }
        
        .qualification-form-fieldset {
          margin: 0 0 20px 0;
          padding: 10px 10px 0;
          border: 1px solid $color_white;
          
          .code {
            width: 150px;
            margin-left: 20px;
            display: inline-block;
            line-height: 1.5;
            white-space: nowrap;
            cursor: pointer;
            text-align: center;
            outline: none;
            border-radius 4px
            padding: 8px 16px;
            background-color: $color_suc;
          }
          
          .waittime {
            background-color: #909399
          }
        }
        .input-icon{
          cursor pointer
          position absolute
          top 0
          right 0
          padding 2px
          border-radius 50%
          color $color_white
          font-size 12px
          z-index 111
          transform translate(39%, -39%)
          background-color $color_suc
        }
      }
      
      .vita-edu-row {
        .chooseYear {
          width 150px
        }
      }
      
      .exp-opt {
        padding: 120px 0 0;
      }
      .display {
        display: flex;
      }
    }
    
    .tips-wrap {
      height: calc(100% - 60px);
      padding: 20px 0;
      position: relative;
      background-color: $block_bg_color_base;
      
      .stuInfoError {
        height: calc(100% - 40px);
        padding-top 70px;
        
        .logo {
          
          font-size: 80px;
          color: $color_suc;
          display flex
          justify-content center
        }
        
        .tips {
          padding: 50px 0 0;
          text-align: center;
          display flex
          justify-content center
          
          p {
            font-size: 17px;
            margin: 10px 0;
          }
          
          p:first-child {
            margin: 0 0 20px 0;
            font-size: 17px;
          }
        }
      }
      
      .btn-wrap {
        display: flex;
        justify-content: center;
        margin-top: 30px;
        margin-left: -20px;
        
        .btn {
          margin: 0 20px;
          padding: 8px 12px;
          border-radius: 3px;
          font-size: $font_size_medium;
          background-color: $color_suc;
          border: none;
          outline: none;
          cursor: pointer;
        }
      }
    }
  }
  
  .flex-center {
    display flex
    align-items center
    justify-content flex-start
  }
  
  .btn-tips {
    color $color_unusual
    cursor pointer
    user-select none
    text-decoration underline
  }
</style>

<style lang="stylus">
  .qualification-form-fieldset
    .el-switch__label
      span
        color #CCCCCC
  
  .no-mb
    margin-bottom 0px !important
  .form-input-item
    display:flex !important
  .input-id-number-input
    .el-form-item__error
      left: -230px;
</style>
